import React, { useState } from "react";
import * as Sentry from "@sentry/nextjs";
import { useToast } from "@/utils";
import { client } from "@/api/client";
import { useForm } from "react-hook-form";
import { FormSubmitButton } from "@/components/base/ui/FormSubmitButton";
import { emailValidate } from "@/validator/email";
import { newPasswordResetRepository } from "@/repositories/passwordReset";
import { NewPasswordInput } from "@/types/passwordReset";
import { Head } from "@/components/base/Head";
import { Breadcrumb } from "@/components/base/Breadcrumb";
import { SectionTitle } from "@/components/base/ui/SectionTitle";

const NewPasswordPage = () => {
  const META_TITLE = "パスワードの再設定";
  const breadcrumbs = [
    {
      title: META_TITLE,
    },
  ];
  const repository = newPasswordResetRepository(client);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const toast = useToast();
  const [loading, setLoading] = useState(false);

  const onFinish = async (data: any) => {
    setLoading(true);
    try {
      data.redirect_url = `${process.env.NEXT_PUBLIC_SERVICE_URL}/password/edit`;
      await repository.passwordResetConfirm(data);
      toast.success("メールを送信しました。");
    } catch (e) {
      Sentry.captureException(e);
      toast.error(
        "エラーが発生しました。お手数ですがもう一度時間を開けておためしください"
      );
    } finally {
      reset();
      setLoading(false);
    }
  };

  return (
    <>
      <Head title={META_TITLE} canonicalPath={`/password/new`} />
      <main className={"bg-gray-100 pb-20"}>
        <div className={"mb-10 max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
        <div className={"max-w-[960px] bg-white m-auto p-10 rounded"}>
          <div className={"mb-8"}>
            <div className={"mb-2"}>
              <SectionTitle title={"パスワードの再設定"} isBorder={false} />
            </div>
            <p>
              ご登録されているメールアドレスをご入力ください。
              <br />
              パスワードの再設定を行うためのメールをお送りいたします。
            </p>
          </div>
          <form
            onSubmit={handleSubmit((data) => onFinish(data))}
            className={""}
          >
            <div className={"mb-10"}>
              <div className={"mb-5"}>
                <label className={"md:text-lg mb-2 block"}>
                  メールアドレス
                </label>
                <input
                  type="email"
                  className={"bg-gray-100 p-4 max-w-xl w-full"}
                  {...register("email", {
                    required: true,
                    validate: async (value) => await emailValidate(value),
                  })}
                />
                {errors.email && (
                  <span className={"block text-red-500 mt-2 text-sm"}>
                    {"メールアドレスを入力してください。"}
                  </span>
                )}
              </div>
            </div>
            <FormSubmitButton loading={loading}>送信する</FormSubmitButton>
          </form>
        </div>
      </main>
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}
export default NewPasswordPage;
